import { Role } from "src/api/Role";
import { AdminInhabitant } from "src/api/Admin";
import { MemberInhabitant } from "src/api/Member";
import { ExternInhabitant } from "src/api/Extern";
import { RootInhabitant } from "src/api/Root";
import { User } from "src/api/User";

// Utility functions to decide the organization and related media.
export const OrgUtil = {

    // returns true if the subdomain is demo or the request has a query parameter for org=demo
    isDemo(user: User | null): boolean {
        return user?.organizationId === 999 ||
            window.location.hostname.includes('demo') || 
            window.location.search.includes('org=demo');
    },
    isAlgorithmWatch(user: User | null): boolean {
        return user?.organizationId === 2;
    },
    isCooperaid(user: User | null): boolean {
        return user?.organizationId === 1;
    },
    orgName(user: User | null): string {
        if (OrgUtil.isCooperaid(user)) return 'Co-operaid';
        if (OrgUtil.isAlgorithmWatch(user)) return 'Algorithm Watch';
        return 'Demo';
    },

    // it reflects also the access restrictions: extern->member->admin->root
    isRoleExtern(role: Role): boolean {
        return role === ExternInhabitant || role === 'extern';
    },
    isRoleMember(role: Role): boolean {
        return role === MemberInhabitant || role === 'member';
    },
    isRoleAdmin(role: Role): boolean {
        return role === AdminInhabitant || role === 'admin';
    },
    isRoleRoot(role: Role): boolean {
        return role === RootInhabitant || role === 'root';
    },

    isAllowed(currentRole: Role, expectedRole?: Role): boolean {
        //console.log(`current: ${currentRole}`);
        if (!expectedRole) return true; // Handles undefined case first

        if (OrgUtil.isRoleRoot(expectedRole)) return OrgUtil.isRoleRoot(currentRole);
        if (OrgUtil.isRoleAdmin(expectedRole)) return OrgUtil.isRoleAdmin(currentRole) || OrgUtil.isRoleRoot(currentRole);
        if (OrgUtil.isRoleMember(expectedRole)) {
            return OrgUtil.isRoleMember(currentRole) || OrgUtil.isRoleAdmin(currentRole) || OrgUtil.isRoleRoot(currentRole);
        }
        if (OrgUtil.isRoleExtern(expectedRole)) return OrgUtil.isRoleExtern(currentRole); // extern (or partner) can access only extern roles

        return false;
    },
}
